module.exports = __webpack_public_path__ + "static/media/ap-swiper-pc-1.0689a7c0.png";